<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <div class="account-content">
      <div class="container">
        <!-- Account Logo -->
        <div class="account-logo">
          <a href="/"
            ><img src="assets/img/logominhtien.png" alt="Minh Tiến"
          /></a>
        </div>
        <!-- /Account Logo -->

        <div class="account-box">
          <div class="account-wrapper">
            <h3 class="account-title">Đăng nhập</h3>
            <!-- Account Form -->
            <form @submit.prevent="handleLogin">
              <div class="form-group">
                <label>Tài khoản</label>
                <input
                  class="form-control"
                  type="text"
                  id="username"
                  v-model="username"
                  required
                  placeholder="Nhập username"
                />
              </div>
              <div class="form-group">
                <label>Mật khẩu</label>
                <input
                  class="form-control"
                  id="password"
                  type="password"
                  v-model="password"
                  required
                  placeholder="Nhập mật khẩu"
                />
              </div>
              <div class="form-group text-center">
                <button class="btn btn-primary account-btn" type="submit">
                  Đăng nhập
                </button>
              </div>

              <div v-if="error" class="error-message">
                {{ error }}
              </div>
            </form>
            <!-- /Account Form -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
import api from "@/api/index.js";
import RBAC from "@/api/rbac";
import { usePushStore } from "@/stores/pushStore";

export default {
  data() {
    return {
      username: "",
      password: "",
      error: null,
    };
  },
  methods: {
    async handleLogin() {
      try {
        this.error = null;
        const response = await api.post("/api/auth/login", {
          username: this.username,
          password: this.password,
        });

        const { accessToken, refreshToken, userName, userAvatar } =
          response.data.data;

        // Lưu vào localStorage
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        localStorage.setItem("username", this.username);
        localStorage.setItem("userhoten", userName);
        localStorage.setItem("avatarUrl", userAvatar);

        // const info = await api.get(`api/nguoi-dung?keyword=${this.username}&page=0&size=1`);
        // console.log(info.data.data.content[0])
        // const userInfo =  info.data.data.content[0]
        // localStorage.setItem('user', JSON.stringify(userInfo));

        await RBAC.loadMe();
         try {
        const pushStore = usePushStore();

        // Cập nhật trạng thái hiện tại từ browser
        await pushStore.checkSubscriptionStatus();

        // Nếu trình duyệt cho phép & chưa đăng ký & không đang xử lý -> tự bật
        if (
          pushStore.isPushEnabled &&
          !pushStore.isSubscribed &&
          !pushStore.isLoading
        ) {
          await pushStore.toggleSubscription();
        }
      } catch (e) {
        // Không vì realtime hư mà chặn login, nên chỉ log chơi
        console.warn("Auto realtime subscription failed:", e);
      }

        // Chuyển hướng
        this.$router.push("/");
      } catch (err) {
        this.error = "Tài khoản hoặc mật khẩu không đúng.";
        console.error("Login error:", err);
      }
    },
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  margin-top: 10px;
}
</style>
